// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ContactUs_contact-us__4XPnI {
  background-color: #fff;
  border-radius: 20px;
  margin: 7rem auto 6rem;
  padding: 4rem 6rem;
  max-width: 60rem;
}

.ContactUs_contact-us__header__WEGX1 {
  font-size: var(--text-2xl);
  font-weight: 700;
}

.ContactUs_contact-us__phone__1X0Qv {
  gap: 2rem;
}

.ContactUs_contact-us__text__NE5o7 {
  font-size: var(--text-sm);
  font-weight: 500;
}

.ContactUs_contact-us__phone-link__sWrpc {
  font-size: var(--text-sm);
  font-weight: 500;
}
`, "",{"version":3,"sources":["webpack://./src/components/Layout/DashboardFooter/ContactUs/ContactUs.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB","sourcesContent":[".contact-us {\n  background-color: #fff;\n  border-radius: 20px;\n  margin: 7rem auto 6rem;\n  padding: 4rem 6rem;\n  max-width: 60rem;\n}\n\n.contact-us__header {\n  font-size: var(--text-2xl);\n  font-weight: 700;\n}\n\n.contact-us__phone {\n  gap: 2rem;\n}\n\n.contact-us__text {\n  font-size: var(--text-sm);\n  font-weight: 500;\n}\n\n.contact-us__phone-link {\n  font-size: var(--text-sm);\n  font-weight: 500;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contact-us": `ContactUs_contact-us__4XPnI`,
	"contact-us__header": `ContactUs_contact-us__header__WEGX1`,
	"contact-us__phone": `ContactUs_contact-us__phone__1X0Qv`,
	"contact-us__text": `ContactUs_contact-us__text__NE5o7`,
	"contact-us__phone-link": `ContactUs_contact-us__phone-link__sWrpc`
};
export default ___CSS_LOADER_EXPORT___;
